import Clarity from '@microsoft/clarity';

function readClarityConfig() {
    const meta = document.querySelector('meta[name="clarity-config"]') as HTMLMetaElement | null;
    if (!meta) return { enabled: false, projectId: '' };

    const enabled = (meta.getAttribute('data-enabled') || '').toLowerCase() === 'true';
    const projectId = meta.getAttribute('data-project-id') || '';
    return { enabled, projectId };
}

export function initClarity() {
    if (typeof window === 'undefined') return;

    const { enabled, projectId } = readClarityConfig();
    if (!enabled || !projectId) return;

    const start = () => Clarity.init(projectId);
    if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(start);
    } else {
        setTimeout(start, 0);
    }
}
